import React from 'react';
import './Footer.css';

import { IconContext } from 'react-icons';
import {
  IoLocationSharp,
  IoLogoInstagram,
  // IoLogoLinkedin,
  // IoLogoTwitter,
  // IoLogoVk,
  IoMail,
} from 'react-icons/io5';
import { SiResearchgate } from 'react-icons/si';
import { Link } from 'react-router-dom';

import LogoPhystech from './phystech_logo_tr.png';

const ButtonMailto = ({ mailto, label }) => {
  return (
    <Link
      className="footer__info"
      to="#"
      onClick={(e) => {
        window.location.href = mailto;
        e.preventDefault();
      }}>
      {label}
    </Link>
  );
};

function Footer({ width }) {
  return (
    <>
      <IconContext.Provider value={{ size: width <= 1150 ? 40 : 34, color: '#fff' }}>
        <div className="footer-container" id="Contacts">

          {/* <div className="footer__email">
            <IoMail size={width <= 960 ? 30 : 30} className="footer__infoIcon" />
            <ButtonMailto
              label="contact@swarmtronics.com"
              mailto="mailto:contact@swarmtronics.com"
            />
          </div> */}
          <div className="footer__address">
            <IoLocationSharp size={width <= 960 ? 30 : 30} className="footer__infoIcon" />

            <a
              href="https://goo.gl/maps/y1XcGiXvm5hGLGYJ8"
              rel="noreferrer"
              target="_blank"
              className="footer__info">
              St. Petersburg, Lomonosova st., 9
            </a>
          </div>
          <div className="footer__links">
            <a href="https://www.instagram.com/swarmtronics/">
              <IoLogoInstagram />
            </a>
            {/* <a href="https://twitter.com/swarmtronics">
              <IoLogoTwitter />
            </a> */}
            <a href="https://www.researchgate.net/lab/Nikita-Olekhno-Lab">
              <SiResearchgate size={width <= 1150 ? 35 : 30} />
            </a>
            <a href="https://physics.itmo.ru/en/research-group/59423">
              <img src={LogoPhystech} alt="" width ={120} />
            </a>
          </div>
        </div>
      </IconContext.Provider>
    </>
  );
}

export default Footer;
